import type { RenderComponentProps } from "replo-runtime/shared/types";
import type { Component } from "schemas/component";

import React from "react";

import { useBundleBuilder } from "../BundleBuilderContext";
import { BundleQuantitySelector } from "./BundleQuantitySelector";
import { useProductTileContext } from "./ProductTileContext";

const getCustomProps = (props: Component["props"]) => {
  const { addToBundleText, removeFromBundleText } = props;
  return {
    addToBundleText: addToBundleText as "string" | null,
    removeFromBundleText: removeFromBundleText as "string" | null,
  };
};

export const AddToBundleButton: React.FC<RenderComponentProps> = ({
  component,
  componentAttributes,
}) => {
  const { addToBundleText, removeFromBundleText } = getCustomProps(
    component.props,
  );
  const variant = component.props.variant === "sm" ? "sm" : "lg";
  const { selectedVariantId, productData } = useProductTileContext();
  const {
    isItemInBundle,
    addItemToBundle,
    removeItemFromBundle,
    canAddVariantToBundle,
    allowMultipleOfSameItem,
  } = useBundleBuilder();

  if (!selectedVariantId) {
    return null;
  }

  const isInBundle = isItemInBundle(selectedVariantId);
  const isAbleToAddVariantTobundle = canAddVariantToBundle(selectedVariantId);
  const handleAddToBundle = () => {
    if (!isInBundle) {
      addItemToBundle({
        productId: String(productData?.id),
        variantId: selectedVariantId,
        quantity: 1,
      });
    } else {
      removeItemFromBundle(selectedVariantId);
    }
  };
  const defaultAddLabel = variant === "sm" ? "Add" : "Add To Bundle";
  const addToBundleLabel = addToBundleText ?? defaultAddLabel;
  const removeFromBundleLabel = removeFromBundleText ?? "Remove";
  return isInBundle && allowMultipleOfSameItem ? (
    <BundleQuantitySelector variantId={selectedVariantId} />
  ) : (
    <button
      {...componentAttributes}
      onClick={handleAddToBundle}
      style={{
        width: "100%",
        opacity: !isInBundle && !isAbleToAddVariantTobundle ? 0.4 : 1,
        ...componentAttributes.style,
      }}
    >
      {isInBundle ? removeFromBundleLabel : addToBundleLabel}
    </button>
  );
};
